import { BaseModel } from './base.model';

export interface Tenant {
    id: number;
    name: string;
    description?: string;
    createdat?: string;
}

export class Tenant implements BaseModel {
    id: number;
    name: string;
    description?: string;
    createdat?: string;

    constructor(id?: number, name?: string, description?: string, createdat?: string) {
        if (id !== undefined) this.id = id;
        this.name = name !== undefined ? name : '';
        this.description = description !== undefined ? description : '';
        this.createdat = createdat !== undefined ? createdat : '';
    }

    getApiName(): string { return 'tenant'; }
    getName(): string { return 'Tenant'; }
    getNamePl(): string { return 'Tenants'; }
}